import React from 'react';
import { ApplicationView, useController } from '@aha-app/mvc';
import type { AssistantViewController } from '../AssistantView/AssistantViewController';
import styles from './AssistantView.module.css';
import { AhaAlert } from 'components/common/reactifyWebComponent';
import classnames from 'classnames';

// https://big.aha.io/features/TOOLS-3360
const USER_WARNING_THRESHOLD = 95; // percent
const ACCOUNT_WARNING_THRESHOLD = 98; // percent

export const UsageWarning = ({ inChat = false }) => {
  const controller = useController<AssistantViewController>();
  const { usageData } = controller.state;

  if (
    !usageData ||
    usageData.dismissedWarning ||
    (usageData.user < USER_WARNING_THRESHOLD &&
      usageData.account < ACCOUNT_WARNING_THRESHOLD)
  ) {
    return null;
  }

  const message = usageData.noUsageAvailable
    ? 'No AI credits remaining'
    : 'AI credits running low.';

  const contactMessage = usageData.administerBilling ? (
    <div>
      <a href='/settings/account/billing' target='_blank'>
        Purchase more credits to continue
      </a>
    </div>
  ) : (
    <div>Contact your account admin to add more</div>
  );

  return (
    <div
      className={classnames(styles.usageWarning, {
        [styles.usageWarningInChat]: inChat,
      })}
    >
      <AhaAlert
        type={usageData.noUsageAvailable ? 'danger' : 'warning'}
        dismissable={!usageData.noUsageAvailable}
        onDismissed={() => {
          controller.actionSetUsageData({ dismissedWarning: true });
        }}
      >
        <div slot='heading'>{message}</div>
        {contactMessage}
      </AhaAlert>
    </div>
  );
};

export default ApplicationView(UsageWarning);
